import { motion } from 'framer-motion';

interface MatchesSearchProps {
  name: string;
  onNameChange: (name: string) => void;
  onSearch: () => void;
  loading: boolean;
}

export default function MatchesSearch({ name, onNameChange, onSearch, loading }: MatchesSearchProps) {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
      <div className="max-w-xl mx-auto">
        <div className="flex gap-4">
          <input
            type="text"
            placeholder="Enter your name..."
            className="flex-1 px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-purple-500"
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && onSearch()}
          />
          <button
            onClick={onSearch}
            disabled={loading}
            className="px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors disabled:opacity-50"
          >
            {loading ? (
              <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                className="w-5 h-5 border-2 border-white border-t-transparent rounded-full"
              />
            ) : (
              'Find Matches'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}